import { render, staticRenderFns } from "./ResultSuccess.vue?vue&type=template&id=168a5e80&"
import script from "./ResultSuccess.vue?vue&type=script&lang=js&"
export * from "./ResultSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports